<template>
  <div class="container">
    <Nav></Nav>
    <div class="index_hearderImg">
      <img src="../assets/qingye/Enterprisedynamics.png" alt="" />
    </div>
    <div class="breadcrumb_center">
      <el-breadcrumb
        class="el-breadcrumb__inner"
        separator-class="el-icon-arrow-right"
      >
        <img src="../assets/qingye/indexImg.png" alt="" />
        <div>
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>{{ AsideName }}</el-breadcrumb-item>
        </div>
      </el-breadcrumb>
    </div>
    <div class="parkOverview index_center">
      <div class="parkOverview_right">
        <div class="parkOverview_left">
          <div class="TechnicalBar">
            <el-menu
              class="el-menu-vertical-demo"
              @select="tabClick"
              :default-active="tabIndex"
              mode="horizontal"
              active-text-color="#2968BD"
            >
              <el-menu-item
                @click="OpenDetail(index)"
                :index="item.id + ''"
                v-for="(item, index) in newsTypeList"
                :key="index"
              >
                <span slot="title">{{ item.newType }}</span>
              </el-menu-item>
            </el-menu>
          </div>
        </div>

        <div class="Dynamic flex_col">
          <div class="Dynamic_title">
            <el-divider>
              <div class="Dynamic_title_name">企业动态</div>
              <div class="Dynamic_title_text">Enterprise dynamics</div>
            </el-divider>
            <div class="Dynamic_left_last">
              <div
                class="Dynamic_left_content"
                v-for="(item, index) in newsList"
                :key="index"
                @click="CurrentIndex(index)"
              >
                <img :src="item.imageUrl" alt="" />
                <div class="Dynamic_right_content">
                  <div class="Dynamic_right_content_title">
                    <span>{{ item.title }}</span>
                  </div>
                  <div class="Dynamic_right_content_text">
                    <p>{{ item.summary }}</p>
                  </div>
                  <div class="Dynamic_right_content_bottom">
                    <div>{{ item.updateTime }}</div>
                    <div
                      class="Dynamic_right_content_icon"
                      @click="openNewDetail(item.id)"
                    >
                      <i class="el-icon-right"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Paging
            :total="total"
            @onPageChange="onPageChange"
            :page-size="pageSize"
            :current-page="pageNumber"
          ></Paging>
        </div>
      </div>
    </div>
    <SubmitFrom></SubmitFrom>
    <Foot style="margin-top: 60px"></Foot>
  </div>
</template>
<script>
import Paging from "./components/Paging";
import Nav from "./components/navBar";
import Foot from "./components/Foot";
import SubmitFrom from "./components/SubmitFrom";
import { getNewsListApi, getNewsTypeApi } from "@/api/index";

export default {
  name: "ParkOverview",
  components: {
    Nav,
    Foot,
    SubmitFrom,
    Paging,
  },
  data() {
    return {
      tabIndex: 0,
      AsideName: "企业动态",
      newsList: [],
      newsTypeList: [],
      pageSize: 6,
      pageNumber: 1,
      total: 0,
      currentIndex: 0,
    };
  },
  created() {
    this.getNewsType();
  },
  mounted() {
    this.$cookies.set("tabbar", 1);
    this.$store.state.tabbar = this.$cookies.get("tabbar");
  },
  methods: {
    OpenDetail(index) {
      this.tabIndex = index + 1;
      console.log(index + 1);
      this.getNewsList();
    },
    CurrentIndex(index) {
      this.currentIndex = index;
      console.log(index);
    },
    //分页
    onPageChange(val) {
      console.log(val);
      this.pageNumber = val;
      this.getNewsList();
    },
    //动态详情
    openNewDetail(id) {
      this.$router.push({
        path: "/detail",
        name: "detail",
        query: {
          id: id,
        },
      });
    },
    //切换tab
    tabClick(index) {
      this.pageNumber = 1;
      // this.getNewsList()
    },
    //获取动态类型
    getNewsType() {
      getNewsTypeApi().then((res) => {
        console.log(res);
        this.newsTypeList = res.data;
        this.tabIndex = this.newsTypeList[this.tabIndex].id + "";
        console.log(this.tabIndex);
        this.getNewsList();
      });
    },
    //企业动态列表
    getNewsList() {
      var data = {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        type: this.tabIndex,
      };
      getNewsListApi(data).then((res) => {
        console.log(res);
        this.newsList = res.data.list;
        this.total = res.data.totalCount;
        console.log(this.total);
      });
    },
  },
};
</script>
<style scoped>
.index_center {
  width: 1200px;
  /*width: 1360px;*/
  margin: 0 auto;
}

.breadcrumb_center {
  background-color: #f6f7f8;
  display: flex;
  /*width: 1200px;*/
  justify-content: space-around;
  height: 50px;
  margin: 0 auto;
}

.el-breadcrumb__inner {
  display: flex;
  align-items: center;
  width: 1200px;
  color: #666666;
}

.el-breadcrumb__inner img {
  padding: 0 10px 0px 0;
}

.index_hearderImg {
  display: flex;
  justify-content: center;
}

.index_hearderImg img {
  width: 100%;
}

.parkOverview {
  display: flex;
}

.parkOverview_left {
  /*width: 150px;*/
  padding-top: 120px;
}

.parkOverview_right {
  padding-top: 60px;
  display: flex;
  justify-content: center;
  width: 100%;
}

.ParkOverview_info .info_block {
  width: 475px;
  /*background: red;*/
  margin-left: 172px;
  /*height: 325px;*/
}

.info_block .title {
  align-items: center;
  justify-content: space-between;
}

.advantage .li {
  width: 460px;
  color: white;
  height: 40px;
  text-align: center;
  margin-top: 15px;
  line-height: 40px;
  border-radius: 20px;
}

.ParkOverview_advantage .info_block {
  width: 475px;
}

.ParkOverview_advantage .img_list {
  width: 490px;
  height: 370px;
  flex-wrap: wrap;
  margin-right: 34px;
}

.ParkOverview_advantage .img_list img {
  margin-bottom: 10px;
  margin-right: 10px;
}

.ParkOverview_advantage .img_list img:nth-child(2n) {
  margin-right: 0px;
}

.ParkOverview_banner .center {
  width: 1200px;
  height: 267px;
  justify-content: space-between;
}

.center .li {
  width: 160px;
  height: 100%;
}

.center .li2 {
  width: 870px;
  height: 100%;
}

.center .li2 >>> .swiper-container {
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
}

.center .li2 >>> .swiper-wrapper {
  height: 100%;
  width: 100% !important;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}

.center .li2 .swiper-slide {
  height: 100%;
}

.center .li2 .item {
  flex: 1;
  height: 100%;
}

.ParkOverview_banner .title {
  align-items: center;
  width: 812px;
  justify-content: center;
}

.organization_list img {
  margin-left: 50px;
  margin-bottom: 10px;
}

.company_top .summary {
  line-height: 30px;
  color: white;
  background: #569fc8;
}

.company_top .li {
  flex: 1;
  height: 100%;
}

.company_bottom .li {
  flex: 1;
  height: 100%;
}

.company_bottom .li2 {
  flex: 2;
  height: 100%;
}

@media (max-width: 1400px) {
  .ParkOverview {
    max-width: 1200px;
  }
}

.ParkOverview_honor_img img {
  width: 972px;
}

div /deep/ .el-breadcrumb__inner.is-link {
  font-weight: normal;
  color: #606266;
}

.TechnicalBar >>> .el-menu--horizontal > .el-menu-item.is-active {
  border-right: 2px solid #2968bd;
  border-bottom: none;
  /*background-color: red;*/
  background-image: linear-gradient(to right, #ffffff, rgba(41, 104, 189, 0.1));
}

.TechnicalBar >>> .el-menu--horizontal > .el-menu-item {
  border-bottom: none;
  /*text-align: center;*/
  width: 140px;
}

.TechnicalBar >>> .el-menu.el-menu--horizontal {
  border-bottom: none;
  /*border-right: 1px solid #E5E5E5;*/
  display: flex;
  flex-direction: column;
  align-items: end;
}

.Dynamic {
  padding-left: 65px;
  width: 1200px;
}

.Dynamic_title {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-bottom: 20px;
  /*width: 1025px;*/
  width: 100%;
  /*text-align: center;*/
}

.Dynamic_title_name {
  font-size: 28px;
  font-weight: 400;
  text-align: center;
}

.Dynamic_title_text {
  font-size: 14px;
  text-align: center;
}

.Dynamic_main_content_date1 p {
  padding-left: 10px;
}

.Dynamic_left_last {
  display: contents;
}

.Dynamic_left_content {
  width: 100%;
  padding: 25px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e5e5e5;
  height: 200px;
}
.Dynamic_left_content img {
  object-fit: cover;
  width: 380px;
  height: 200px;
}

.Dynamic_left_content:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.Dynamic_right_content {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-right: 8%;
  justify-content: space-between;
}

.Dynamic_right_content_icon {
  float: right;
  color: #2968bd;
  border: 2px solid #2968bd;
  border-radius: 50%;
  width: 25px;
  height: 23px;
  text-align: center;
  cursor: pointer;
}

.Dynamic_right_content_title {
  display: flex;
  font-size: 16px;
  color: #333333;
  padding-bottom: 15px;
}

.Dynamic_right_content_text {
  width: 500px;
  font-size: 14px;
  color: #666666;
  line-height: 30px;
}

.Dynamic_right_content_text p {
  /*超过三行省略号*/
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
}

.Dynamic_right_content_bottom {
  padding-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.el-divider--horizontal {
  margin-bottom: 80px;
}

.pagination {
  padding-top: 88px;
}
</style>



// WEBPACK FOOTER //
// src/views/ParkOverview.vue